import React from "react";
import styled from "styled-components";
import { lightThemeColors } from "../../assets/style/colors";
import { ReactComponent as Check } from "../../assets/icons/pricingPlan/check.svg";
import { ReactComponent as NotChecked } from "../../assets/icons/pricingPlan/line.svg";
import { ReactComponent as Free } from "../../assets/icons/pricingPlan/free.svg";
import { ReactComponent as ScaleUp } from "../../assets/icons/pricingPlan/scaleUp.svg";
import { ReactComponent as Enterprise } from "../../assets/icons/pricingPlan/enterprise.svg";
import GrovsComparationTable from "../Marketing/GrovsComparationTable";

const ComparePlans = () => {
  const compareLists = [
    {
      category: "Engagement",
      subcategory: [
        {
          subcategoryTitle: "Smart Dynamic Linking",
          free: true,
          scaleUp: true,
          enterprise: true,
        },
        {
          subcategoryTitle: "Deferred Deep Linking",
          free: true,
          scaleUp: true,
          enterprise: true,
        },
        {
          subcategoryTitle: "Custom Social Previews",
          free: true,
          scaleUp: true,
          enterprise: true,
        },
        {
          subcategoryTitle: "Advanced Link Tracking",
          free: true,
          scaleUp: true,
          enterprise: true,
        },
        {
          subcategoryTitle: "Google Analytics & UTM Support",
          free: true,
          scaleUp: true,
          enterprise: true,
        },
        {
          subcategoryTitle: "Fully Editable Links",
          free: true,
          scaleUp: true,
          enterprise: true,
        },
        {
          subcategoryTitle: "Custom Short Links",
          free: true,
          scaleUp: true,
          enterprise: true,
        },
        {
          subcategoryTitle: "Branded Links",
          free: true,
          scaleUp: true,
          enterprise: true,
        },
      ],
    },
    {
      category: "Measure",
      subcategory: [
        {
          subcategoryTitle: "Track Installs, Engagement, ROI, and more",
          free: true,
          scaleUp: true,
          enterprise: true,
        },
        {
          subcategoryTitle: "Group and Compare Campaigns",
          free: true,
          scaleUp: true,
          enterprise: true,
        },
        {
          subcategoryTitle: "Data Exports (CSV)",
          free: true,
          scaleUp: true,
          enterprise: true,
        },
      ],
    },
    {
      category: "Analyse",
      subcategory: [
        {
          subcategoryTitle: "Link Performance",
          free: true,
          scaleUp: true,
          enterprise: true,
        },
        {
          subcategoryTitle: "Campaign Comparison",
          free: true,
          scaleUp: true,
          enterprise: true,
        },
        {
          subcategoryTitle: "User-Level Insights",
          free: true,
          scaleUp: true,
          enterprise: true,
        },
        {
          subcategoryTitle: "Referral Tracking",
          free: true,
          scaleUp: true,
          enterprise: true,
        },
        {
          subcategoryTitle: "Flexible Dashboards & Filters",
          free: true,
          scaleUp: true,
          enterprise: true,
        },
      ],
    },
    {
      category: "Cross-Platform Messaging",
      subcategory: [
        {
          subcategoryTitle: "In-App Messaging",
          free: true,
          scaleUp: true,
          enterprise: true,
        },
        {
          subcategoryTitle: "In-App Inbox",
          free: true,
          scaleUp: true,
          enterprise: true,
        },
        {
          subcategoryTitle: "User Base Separation ",
          free: true,
          scaleUp: true,
          enterprise: true,
        },
        {
          subcategoryTitle: "Fully Customizable Messages",
          free: true,
          scaleUp: true,
          enterprise: true,
        },
      ],
    },
    {
      category: "Attributions",
      subcategory: [
        {
          subcategoryTitle: "Real-time mobile measurement and reporting",
          free: true,
          scaleUp: true,
          enterprise: true,
        },
        {
          subcategoryTitle: "Multi-touch attribution",
          free: true,
          scaleUp: true,
          enterprise: true,
        },
      ],
    },
    {
      category: "APIs",
      subcategory: [
        {
          subcategoryTitle: "Link creation",
          free: true,
          scaleUp: true,
          enterprise: true,
        },
        {
          subcategoryTitle: "Link details",
          free: true,
          scaleUp: true,
          enterprise: true,
        },
        {
          subcategoryTitle: "Data export",
          free: false,
          scaleUp: false,
          enterprise: true,
        },
      ],
    },
    {
      category: "Compliance",
      subcategory: [
        {
          subcategoryTitle: "iOS 13+",
          free: true,
          scaleUp: true,
          enterprise: true,
        },
        {
          subcategoryTitle: "Android 5+",
          free: true,
          scaleUp: true,
          enterprise: true,
        },
        {
          subcategoryTitle: "Data protection compliance",
          free: true,
          scaleUp: true,
          enterprise: true,
        },
      ],
    },
    {
      category: "Access",
      subcategory: [
        {
          subcategoryTitle: "2-factor-authentication (2FA)",
          free: true,
          scaleUp: true,
          enterprise: true,
        },
        {
          subcategoryTitle: "Login and password management",
          free: true,
          scaleUp: true,
          enterprise: true,
        },
        {
          subcategoryTitle: "Single sign-on (SSO)",
          free: true,
          scaleUp: true,
          enterprise: true,
        },
        {
          subcategoryTitle: "User management",
          free: true,
          scaleUp: true,
          enterprise: true,
        },
      ],
    },
    {
      category: "Audit",
      subcategory: [
        {
          subcategoryTitle: "Audit Logs",
          free: false,
          scaleUp: false,
          enterprise: true,
        },
      ],
    },
    {
      category: "Support & Services",
      subcategory: [
        {
          subcategoryTitle: "Audit Logs",
          free: true,
          scaleUp: true,
          enterprise: true,
        },
        {
          subcategoryTitle: "Self-service help center",
          free: true,
          scaleUp: true,
          enterprise: true,
        },
        {
          subcategoryTitle: "On-Platform live support",
          free: true,
          scaleUp: true,
          enterprise: true,
        },
        {
          subcategoryTitle: "Email support",
          free: false,
          scaleUp: true,
          enterprise: true,
        },
        {
          subcategoryTitle: "Integration support",
          free: false,
          scaleUp: true,
          enterprise: true,
        },
        {
          subcategoryTitle: "Dedicated Customer Success Manager",
          free: false,
          scaleUp: false,
          enterprise: true,
        },
        {
          subcategoryTitle: "Migration & onboarding support",
          free: false,
          scaleUp: false,
          enterprise: true,
        },
      ],
    },
  ];

  return (
    <OuterWrapper>
      <Container>
        <Line>
          <TextWrapper>
            <Title>Compare plans</Title>
            <Subtitle>Have any questions? Contact sales.</Subtitle>
          </TextWrapper>
        </Line>
        <CompareList>
          <CompareListItem style={{ border: "none" }}>
            <CompareListTitleItemCell style={{ justifyContent: "unset" }}>
              {" "}
              <CompareListTitle> Plans</CompareListTitle>
            </CompareListTitleItemCell>
            <CompareListTitleItemCell>
              <Free />
              <CompareListTitle>Free</CompareListTitle>
            </CompareListTitleItemCell>
            <CompareListTitleItemCell>
              <ScaleUp />
              <CompareListTitle>ScaleUp</CompareListTitle>
            </CompareListTitleItemCell>
            <CompareListTitleItemCell>
              <Enterprise />
              <CompareListTitle>Enterprise</CompareListTitle>
            </CompareListTitleItemCell>
          </CompareListItem>
        </CompareList>
        {compareLists.map((category, index) => (
          <CompareList key={index}>
            <CompareListHeader>
              <CompareListTitleSection>
                {category.category}
              </CompareListTitleSection>
            </CompareListHeader>
            {category.subcategory.map((subcategory, index) => (
              <CompareListItem key={index}>
                <CompareListItemTitle>
                  {subcategory.subcategoryTitle}
                </CompareListItemTitle>
                <CompareListItemCheck>
                  {subcategory.free ? <Check /> : <NotChecked />}
                </CompareListItemCheck>
                <CompareListItemCheck>
                  {subcategory.scaleUp ? <Check /> : <NotChecked />}
                </CompareListItemCheck>
                <CompareListItemCheck>
                  {subcategory.enterprise ? <Check /> : <NotChecked />}
                </CompareListItemCheck>
              </CompareListItem>
            ))}
          </CompareList>
        ))}
      </Container>
    </OuterWrapper>
  );
};

export default ComparePlans;

const Container = styled.div`
  width: 100%;
  z-index: 1;
  display: flex;
  flex-direction: column;
  gap: 30px;
padding:150px 100px 80px;
  @media (max-width: 990px) {
    padding: 20px;
    gap: 50px;
  }

  max-width: 1512px;
  margin-left: auto;
  margin-right: auto;
`;
const OuterWrapper = styled.div`
  background: rgba(246, 244, 242, 1);
`;
const Line = styled.div`
  display: flex;
  align-items: center;
  gap: 25px;
  width: 100%;
  overflow: hidden;
  flex-direction: ${(props) => (props.reverse ? "row-reverse" : "initial")};
  @media (max-width: 990px) {
    gap: 10px;
    flex-direction: column;
  }
  margin-bottom: 40px;
`;
const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  gap: 10px;
  max-width: 850px;
  margin: auto;
`;

const Title = styled.h1`
  color: ${lightThemeColors.darkColor};
  font-size: 36px;
  font-weight: 700;
  line-height: 46px;
  text-align: center;
  @media (max-width: 990px) {
    font-size: 30px;
    line-height: 36px;
    text-align: center;
  }
`;

const Subtitle = styled.p`
  color: ${lightThemeColors.darkColorFaded};
  font-size: 18px;
  font-weight: 400;
  line-height: 30px;
  text-align: center;
`;

const CompareList = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

const CompareListHeader = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  margin-bottom: 20px;
  width: 100%;
`;

const CompareListTitle = styled.p`
  color: ${lightThemeColors.darkColor};
  font-weight: 600;
  font-size: 24px;
  line-height: 30px;

  @media (max-width: 990px) {
    font-size: 18px;
    line-height: 22px;
  }
`;

const CompareListTitleSection = styled.p`
  color: ${lightThemeColors.darkColor};
  font-weight: 600;
  font-size: 20px;
  line-height: 30px;

  @media (max-width: 990px) {
    font-size: 18px;
    line-height: 22px;
  }
`;
const CompareListItem = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
  width: 100%;
  padding: 8px 0;
  border-top: 1px solid rgba(237, 235, 234, 1);
  @media (max-width: 990px) {
    gap: 15px;
  }
`;
const CompareListItemTitle = styled.p`
  color: ${lightThemeColors.darkColor};
  font-weight: 400;
  font-size: 16px;
  line-height: 26px;
  width: 100%;
  @media (max-width: 990px) {
    font-size: 16px;
    line-height: 20px;
  }
`;
const CompareListItemCheck = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  gap: 10px;
  svg {
    height: 13px;
    width: 18px;
  }
  @media (max-width: 990px) {
    svg {
      height: 10px;
      width: 14px;
    }
  }
`;

const CompareListTitleItemCell = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  gap: 10px;
  @media (max-width: 990px) {
    flex-direction: column;
  }
  svg {
    height: 35px;
    width: 35px;
  }
`;
